import type { CvModelData } from '@/app/cv/types/model-data';

export const EURO3_FRR_210_190: CvModelData = {
  href: '/product/euro-3/frr',
  label: 'FRR 210/190',
  image: {
    src: 'https://assets.isuzu-tis.com/frr_210_190_center_021a78ee93.png',
    alt: 'FRR 210/190',
    width: 1600,
    height: 1200,
  },
  brochureHref:
    'https://assets.isuzu-tis.com/frr_euro3_brochure_0cc5d2dcf5.pdf',
  engineType: 'euro-3',
  features: [
    {
      detail: '210 แรงม้า<br />190 แรงม้า',
    },
    {
      detail: '637 N-m ที่ 1,600 RPM<br />510 N-m ที่ 1,600 - 2,600 RPM',
    },
    {
      detail: 'GVW 9.9 - 10.4 ตัน',
    },
    {
      detail: '6 เกียร์เดินหน้า',
    },
  ],
};
